const maxLengthPhoneNumber = (phone: string) => {
  if (phone.startsWith("08")) {
    return 14;
  }

  return 15;
};
export default maxLengthPhoneNumber;
